import { api } from "@api/api";
import { Partner } from "@modules/partners/types";
import { PartnerFormValues } from "@modules/partners/validations";

export async function createPartnerService(
  data: PartnerFormValues
): Promise<Partner> {
  const { data: partner } = await api.post<Partner>("/v1/partner_admin/", data);
  return partner;
}
